// import { ButtonComponent } from "./components/button/ButtonComponent";
// import Router from "./router/Router";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useEffect, useState } from "react";
import Login from "./pages/auth/Login"
import Home from "./pages/modules/Admin/DashBoard/Home/Home"
import Dashboard from "./pages/modules/Admin/DashBoard/DashBoard"
import ProtectedRoute from './router/ProtectedRoute';
import { UserProvider } from './context/UserContext';
import "./index.css"
import { useDispatch } from 'react-redux';
import { handleEcSdkData } from './redux/action/ecSdk/ecSdkThunks';
import HandleUserData from '@src/auth/HandleUserData';

function App() {
  const ecSdk = require("ec-sdk")({}, require("./ec-sdk-config/app-config.json"))
  const dispatch = useDispatch()
  const authentication_key = localStorage.getItem('authentication_key');
  useEffect(() => {
    dispatch(handleEcSdkData(ecSdk))
  }, []) 
  useEffect(() => {
    HandleUserData(ecSdk, dispatch)
  }, [authentication_key])
  return (<>
  <UserProvider>
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/modules/*" element={<ProtectedRoute element={<Dashboard />} />} />
    </Routes>
    <ToastContainer position="top-center" />
    </UserProvider>
  </>);
}

export default App;
